export const links = [
  {
    name: "Services",
    submenu: true,
    sublinks: [
      {
        Head: "Development",
        sublink: [
          { name: "Web Development", link: "/webdevelopment" },
          { name: "App Development", link: "/mobileapp" },
          { name: "E-commerce Development", link: "/ecommerce-development" },
          { name: "WordPress Development", link: "/wordpress-development" },
          { name: "Custom Software Development", link: "/custom-software" },
        ],
      },
      {
        Head: "Design",
        sublink: [
          { name: "UI/UX Design", link: "/uidesign" },
          { name: "Web Design", link: "/webdesign" },
          { name: "Webflow Design", link: "/webflow" },
          { name: "SaaS Design", link: "/saas-design" },
          { name: "Graphic Design", link: "/graphic-design" },
          { name: "Product Design", link: "/product-design" },
        ],
      },
      {
        Head: "Branding",
        sublink: [
          { name: "Brand Strategy", link: "/brand-strategy" },
          { name: "Logo Design", link: "/logo-design" },
          { name: "Brand Identity", link: "/brand-identity" },
          { name: "Marketing Materials", link: "/marketing-materials" },
        ],
      },
      {
        Head: "Digital Marketing",
        sublink: [
          { name: "SEO Services", link: "/seo-services" },
          { name: "Social Media Marketing", link: "/social-media-marketing" },
          { name: "Content Marketing", link: "/content-marketing" },
          { name: "Email Marketing", link: "/email-marketing" },
        ],
      },
      {
        Head: "Video & Animation",
        sublink: [
          { name: "Video Editing", link: "/video-editiong" },
          { name: "Motion Graphics", link: "/motion-graphics" },
          { name: "Explainer Videos", link: "/explainer-videos" },
          { name: "3D Animation", link: "/3d-animation" },
        ],
      },
    ],
  },
];
